import {
  ExportIntegrationStatus,
  ExportItem,
} from '@aibees/elephant/hooks/types';
import { Chip } from '@aibees/shared/components';
import { ExportStatus } from '@aibees/shared/components/status-tag';
import { Stack, Tooltip } from '@mui/material';
import { ExportFileAction } from '../actions/export-file-action';
import { colorMap, humanReadableExportStatus } from '../utils';

interface ExportFileStatusCellProps {
  item: ExportItem;
  rowNumber: number;
}

export const ExportFileStatusCell = ({
  item,
  rowNumber,
}: ExportFileStatusCellProps) => {
  if (
    item.status === ExportStatus.SUCCESS &&
    item.integrations?.SMART_LEAD?.status !== ExportIntegrationStatus.FAILED &&
    item.integrations?.SMART_LEAD?.status !== ExportIntegrationStatus.PROCESSING
  ) {
    return <ExportFileAction item={item} rowNumber={rowNumber} />;
  } else if (
    item.status === ExportStatus.SUCCESS &&
    item.integrations?.SMART_LEAD?.status === ExportIntegrationStatus.FAILED
  ) {
    return (
      <Stack width="100%">
        <Tooltip
          title="Export Failed — open Actions to Retry or See More details."
          placement="bottom"
        >
          <Chip size="small" label="Failed" color="error" />
        </Tooltip>
      </Stack>
    );
  } else if (
    item.status === ExportStatus.SUCCESS &&
    item.integrations?.SMART_LEAD?.status === ExportIntegrationStatus.PROCESSING
  ) {
    return (
      <Stack width="100%">
        <Chip size="small" label="Processing" color="warning" />
      </Stack>
    );
  }

  return (
    <Stack width="100%">
      <Chip
        size="small"
        label={humanReadableExportStatus(item.status)}
        color={colorMap[item.status]}
        key={item.status}
      />
    </Stack>
  );
};
